!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.sessionKey = "swipeHintShown", this.hasShown = this.checkSessionStorage(), 
      this.sliderContainer = null, this.observer = null;
    }
    connectedCallback() {
      this.init();
    }
    init() {
      if (window.innerWidth > 1024) return;
      if (this.sliderContainer = this.querySelector("[data-slider]"), !this.sliderContainer) return;
      if (this.querySelectorAll("[data-slide]").length <= 1) return;
      if (this.hasShown) return;
      document.querySelectorAll("swipe-hint")[0] === this && this.setupIntersectionObserver();
    }
    checkSessionStorage() {
      return "true" === sessionStorage.getItem(this.sessionKey);
    }
    markAsShown() {
      sessionStorage.setItem(this.sessionKey, "true");
    }
    setupIntersectionObserver() {
      this.observer = new IntersectionObserver(e => {
        e.forEach(e => {
          e.isIntersecting && !this.hasShown && setTimeout(() => {
            this.animateSwipeHint(), this.hasShown = !0, this.markAsShown(), this.observer.disconnect();
          }, 1e3);
        });
      }, {
        threshold: .3,
        rootMargin: "0px"
      }), this.observer.observe(this);
    }
    animateSwipeHint() {
      this.sliderContainer && (this.sliderContainer.classList.add("animate-nudge-swipe"), 
      setTimeout(() => {
        this.sliderContainer.classList.remove("animate-nudge-swipe");
      }, 1500));
    }
    disconnectedCallback() {
      this.observer && this.observer.disconnect();
    }
  }
  customElements.get("swipe-hint") || customElements.define("swipe-hint", e);
}();